(function () {
  if (window.__hkCardInit) return;
  window.__hkCardInit = true;
  document.addEventListener('click', function (e) {
    var card = e.target.closest('.hk-product-card');
    if (!card) return;
    if (e.target.closest('a, button, form, input, quick-add-modal, modal-opener, modal-dialog, quick-add-bulk')) return;
    var link = card.querySelector('.hk-card__title a');
    if (link && link.href) window.location.href = link.href;
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.hk-btn');
    if (!btn) return;
    var r = document.createElement('span');
    r.className = 'hk-ripple';
    var rect = btn.getBoundingClientRect();
    var size = Math.max(rect.width, rect.height) * 1.5;
    r.style.cssText = 'width:'+size+'px;height:'+size+'px;left:'+(e.clientX-rect.left-size/2)+'px;top:'+(e.clientY-rect.top-size/2)+'px;';
    btn.appendChild(r);
    r.addEventListener('animationend', function(){ r.remove(); });
  });
})();